import { useContext, useEffect } from 'react';

import CraRdvContext from '../Contexts/CraRdvProvider';
import { getCalendarMonthMatrix } from '../Utils/getCalendarMonthMatrix';

const useCraRdv = () =>{
    // ? this is just a simple example of a custom hook with contextAPI
    // -----
    const { monthCalendarIndex,setCalendarMonthMatrix } = useContext(CraRdvContext);
    // a chaque fois on change le moix index du calendrier [1,..12,13,,,] on mis a jour le calendrier avec le bon moi,annee:
    // ? proof : {dayjs(new Date(dayjs().year(), monthCalendarIndex)).format('MMMM YYYY')}
    // va return le bon date, mm l'index depasse 12, car on se base sur l'annee courante :)
    useEffect(() => {
        // console.log('chanuseCraRdv[monthCalendarIndex]',monthCalendarIndex);
        setCalendarMonthMatrix(getCalendarMonthMatrix({monthCra:monthCalendarIndex}));
    }, [monthCalendarIndex]);
    // -----
    return useContext(CraRdvContext);
};

export default useCraRdv;